var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-textarea',{attrs:{"placeholder":"Enter text","rows":"3","max-rows":"6"},model:{value:(_vm.question.GivenAnswer),callback:function ($$v) {_vm.$set(_vm.question, "GivenAnswer", $$v)},expression:"question.GivenAnswer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2fe58a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/types/Text.vue
// module id = null
// module chunks = 